export const TASK_STATUSES = {
  notCompleted: { label: 'Not Completed', value: 'not_completed' },
  completed: { label: 'Completed', value: 'completed' },
  overdue: { label: 'Overdue', value: 'overdue' }
};

export const TASK_TYPES = {
  call: { label: 'Call', value: '1' },
  email: { label: 'Email', value: '2' },
  meeting: { label: 'Meeting', value: '3' },
  note: { label: 'Note', value: '6' },
  renewalReminder: { label: 'Lease Renewal', value: '5' },
  other: { label: 'Other', value: '4' },
  showing: { label: 'Showing Tour', value: '7' },
  criticalDate: { label: 'Critical Date', value: '9' }
};

export const VIEW_TASKS_LIST = 'VIEW-TASKS_LIST';
export const VIEW_TASKS_PROJECTS = 'VIEW-TASKS_PROJECTS';
